import { Component, Host, Optional, OnInit, ElementRef, Input } from '@angular/core';

import * as _ from 'lodash';

import { CardColumnsComponent } from './components/columns/columns.component';
import { CardDeckComponent } from './components/deck/deck.component';
import { CardGroupComponent } from './components/group/group.component';

/**
 * Define estilos de cards para blocos.
 *
 * Ã uma abstraÃ§Ã£o para o [card do Bootstrap 4]{@link https://getbootstrap.com/docs/4.1/components/card}, com algumas melhorias e estilos personalizados.
 *
 * Demo: {@link https://gituex.gitlab.io/extensions/web-extensions#components/card}
 */
@Component({
  selector: 'uex-card',
  templateUrl: './card.component.html',
  host: {
    '[class.uex-card-wrapper]': 'has_wrapper',
    '[class.uex-card]': '!has_wrapper',
    '[class.card]': '!has_wrapper'
  }
})
export class CardComponent implements OnInit {
  @Input('no-wrapper') private set _setNoWrapper(no_wrapper: boolean | string) {
    if (_.isString(no_wrapper) && _.isEmpty(no_wrapper)) {
      this._no_wrapper = true;
    } else {
      this._no_wrapper = !!no_wrapper;
    }

    if (this.has_wrapper && this._no_wrapper) {
      this.has_wrapper = !this._no_wrapper;
    }
  }

  /**
   * @ignore
   */
  constructor(
    public elementRef: ElementRef,
    @Host() @Optional() private _columnsParent: CardColumnsComponent,
    @Host() @Optional() private _deckParent: CardDeckComponent,
    @Host() @Optional() private _groupParent: CardGroupComponent
  ) { }

  /**
   * @internal
   */
  public has_wrapper = true;
  private _no_wrapper = false;

  public ngOnInit() {
    const parent = this.elementRef.nativeElement.parentElement;
    const columns_parent = this._columnsParent ? this._columnsParent.elementRef.nativeElement : null;
    const deck_parent = this._deckParent ? this._deckParent.elementRef.nativeElement : null;
    const group_parent = this._groupParent ? this._groupParent.elementRef.nativeElement : null;
    switch (parent) {
      case columns_parent:
      case deck_parent:
      case group_parent:
        this.has_wrapper = false;
        break;
      default:
        this.has_wrapper = !this._no_wrapper;
    }
  }

  /**
   * Retorna a distÃ¢ncia do elemento para o topo do elemento pai mais prÃ³ximo posicionado com relative
   */
  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }
}
